import { defineStore } from 'pinia'
import { ref } from 'vue'
import axiosInstance from '@/helpers/axios'
import { SwalSuccess, SwalError, SwalDelete } from '@/helpers/mySwal'

export const useJobCategoryStore = defineStore('jobCategory', () => {
  const jobCategories = ref([])
  const jobCategory = ref({})
  const loading = ref(false)
  const isLoaded = ref(false)
  const isLoadedOne = ref(false)

  const getAllJobCategories = async () => {
    if (loading.value) {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      await getAllJobCategories()
    } else if (!isLoaded.value) {
      await readAllJobCategories()
    }
  }

  const readAllJobCategories = async () => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get('/api/jobCategories')
      jobCategories.value = data
      isLoaded.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת קטגוריות נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const getOneJobCategory = async (id) => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get(`/api/jobCategories/${id}`)
      jobCategory.value = data
      isLoadedOne.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת קטגוריה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const createJobCategory = async (data) => {
    loading.value = true
    try {
      const { data: jobCategory } = await axiosInstance.post('/api/jobCategories', data)
      if (isLoaded.value) {
        jobCategories.value.push(jobCategory)
      }

      SwalSuccess.fire({
        title: 'קטגוריה חדשה נוצר בהצלחה'
      })

      return jobCategory.id
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'הוספת קטגוריה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const updateJobCategory = async (data) => {
    loading.value = true
    try {
      const { data: updatedJobCategory } = await axiosInstance.put(
        `/api/jobCategories/${data.id}`,
        data
      )

      if (isLoaded.value) {
        jobCategories.value = jobCategories.value.map((jobCategory) =>
          jobCategory.id === data.id ? updatedJobCategory : jobCategory
        )
      }

      if (isLoadedOne.value) {
        jobCategory.value = updatedJobCategory
      }

      SwalSuccess.fire({
        title: 'פרטי הקטגוריה עודכנו בהצלחה'
      })

      return updatedJobCategory.id
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'עדכון קטגוריה נכשל'
      })
    } finally {
      loading.value = false
    }
  }

  const deleteJobCategory = async (id) => {
    loading.value = true
    try {
      await axiosInstance.delete(`/api/jobCategories/${id}`)
      if (isLoaded.value) {
        jobCategories.value = jobCategories.value.filter((jobCategory) => jobCategory.id !== id)
      }

      SwalSuccess.fire({
        title: 'פרטי הקטגוריה נמחקו בהצלחה'
      })
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'מחיקת קטגוריה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const confirmDelete = async (id) => {
    const confirm = await SwalDelete.fire({
      text: `האם אתה בטוח שברצונך למחוק את הקטגוריה?`
    })

    if (confirm.isConfirmed) {
      await deleteJobCategory(id)
    }
  }

  const reorderJobCategories = async (data) => {
    jobCategories.value = data

    try {
      await axiosInstance.put('/api/jobCategories/reorder', data)
    } catch (error) {
      console.error(error)
      readAllJobCategories()
      SwalError.fire({
        title: 'עדכון סדר הקטגוריות נכשל'
      })
    }
  }

  const $reset = () => {
    jobCategories.value = []
    jobCategory.value = {}
    loading.value = false
    isLoaded.value = false
    isLoadedOne.value = false
  }

  return {
    jobCategories,
    jobCategory,
    loading,
    isLoaded,
    isLoadedOne,
    getAllJobCategories,
    getOneJobCategory,
    createJobCategory,
    updateJobCategory,
    deleteJobCategory,
    confirmDelete,
    reorderJobCategories,
    $reset
  }
})
